<section class="ai-hero" [class.ai-hero--drawer]="variant !== 'home'" [class.ai-hero--page]="variant === 'page'">
  <div class="ai-hero__blob ai-hero__blob--1"></div>
  <div class="ai-hero__blob ai-hero__blob--2"></div>

  <div class="ai-hero__content">
    @if (!active) {
      <div class="ai-hero__header">
        <i class="pi pi-sparkles ai-hero__sparkles"></i>
        <h2 class="ai-hero__title">{{ greeting }}</h2>
        <button class="ai-chat__icon-btn" (click)="openFullView()" title="Agrandir">
          <i class="pi pi-window-maximize"></i>
        </button>
      </div>
    } @else {
      <div class="ai-chat">
        <div class="ai-chat__header">
          <div class="ai-chat__header-left">
            <i class="pi pi-sparkles"></i>
            <span>Assistant EVA</span>
          </div>
          <div class="ai-chat__header-actions">
            <button
              class="ai-chat__icon-btn"
              [class.ai-chat__icon-btn--active]="showHistory"
              (click)="toggleHistory()"
              title="Historique des conversations"
            >
              <i class="pi pi-history"></i>
            </button>
            @if (variant === "drawer") {
              <button class="ai-chat__icon-btn" (click)="openFullView()" title="Agrandir">
                <i class="pi pi-window-maximize"></i>
              </button>
            }
            <button class="ai-chat__icon-btn" (click)="reset()" title="Nouvelle conversation">
              <i class="pi pi-plus"></i>
            </button>
            @if (variant === "drawer") {
              <button class="ai-chat__icon-btn" (click)="closed.emit()" title="Fermer">
                <i class="pi pi-times"></i>
              </button>
            }
          </div>
        </div>

        <div class="ai-home-chat__body">
          @if (showHistory) {
            <div class="ai-chat__history">
              @if (loadingHistory) {
                <div class="ai-chat__history-empty">
                  <i class="pi pi-spin pi-spinner"></i>
                  <span>Chargement...</span>
                </div>
              } @else {
                @for (conv of conversations; track conv.id) {
                  <div class="ai-chat__history-item" [class.ai-chat__history-item--active]="conv.id === conversationId">
                    <button
                      type="button"
                      class="ai-home-chat__history-open"
                      [title]="conv.title"
                      (click)="open(conv.id)"
                    >
                      <span class="ai-chat__history-item-title">
                        @if (isBusy(conv.id)) {
                          <i class="pi pi-spin pi-spinner" title="L'assistant réfléchit"></i>
                        }
                        {{ conv.title }}
                      </span>
                      <span class="ai-chat__history-item-meta">
                        {{ conv.updated_at | date: "dd.MM.yyyy HH:mm" }}
                        @if (cost(conv); as c) {
                          <span aria-hidden="true">·</span> {{ c }}
                        }
                      </span>
                    </button>
                    <eva-popover
                      #itemMenu
                      position="bottom"
                      align="end"
                      [showArrow]="false"
                      width="200px"
                      appendTo="body"
                    >
                      <button
                        trigger
                        type="button"
                        class="ai-home-chat__history-more"
                        title="Actions sur la conversation"
                        [attr.aria-label]="'Actions sur « ' + conv.title + ' »'"
                      >
                        <i class="pi pi-ellipsis-h"></i>
                      </button>
                      <div content class="ai-history__actions">
                        <button
                          type="button"
                          class="ai-history__action ai-history__action--danger"
                          [disabled]="isBusy(conv.id)"
                          (click)="itemMenu.hide(); remove(conv.id)"
                        >
                          <i class="pi pi-trash"></i> Supprimer
                        </button>
                      </div>
                    </eva-popover>
                  </div>
                } @empty {
                  <div class="ai-chat__history-empty">
                    <span>Aucune conversation précédente</span>
                  </div>
                }
              }
            </div>
          }

          <app-ai-thread
            class="ai-chat__messages"
            [messages]="messages"
            [conversationId]="conversationId"
            [pending]="pending"
            [busy]="busy"
            [progress]="progress"
            (decided)="decide($event)"
            (restart)="reset()"
          >
            @if (variant !== "home") {
              <p class="ai-home-chat__welcome">
                Comment puis-je vous aider ? Posez une question, dictez-la ou déposez des PDF.
              </p>
            }
          </app-ai-thread>
        </div>
      </div>
    }

    <app-ai-composer
      [busy]="busy"
      [lockedModel]="conversationModel"
      [placeholder]="active ? 'Posez une question de suivi…' : 'Posez votre question ou déposez vos PDF…'"
      (modelChange)="newModel = $event"
      (submitted)="send($event)"
      (stopped)="stop()"
    />

    @if (resumable) {
      <div class="ai-hero__suggestions">
        <button class="ai-hero__suggestion-tag ai-hero__suggestion-tag--resume" (click)="resume()">
          @if (busy) {
            <i class="pi pi-spin pi-spinner"></i> L'assistant réfléchit… voir la conversation
          } @else {
            <i class="pi pi-replay"></i> Reprendre la conversation
          }
        </button>
      </div>
    }
  </div>
</section>
